module.exports = __webpack_public_path__ + "img/nox@2x.c2b54c7d.png";